// FilterByDrillDownDto.js

class FilterByDrillDownDto {
    actionType = String();
    actionDetail = String();
    searchCondition = String();
    dateType = String();
    dateFrom = String(); //new Date().toISOString()
    dateTo = String();
    dateTerm = String();
    dateUnit = String();
    orTag = String();
    exceptTag = String();
    tag = String();
    sort = String();
    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();
    contentTypes = String();
    hitNumber = String();
    operationScreen = String();
    viewName = String();

    constructor(data) {
        this.actionType = data.actionType;
        this.actionDetail = data.actionDetail;
        this.searchCondition = data.searchCondition;
        this.dateType = data.dateType;
        this.dateFrom = data.dateFrom;
        this.dateTo = data.dateTo;
        this.dateTerm = data.dateTerm;
        this.dateUnit = data.dateUnit;
        this.orTag = data.orTag;
        this.exceptTag = data.exceptTag;
        this.tag = data.tag;
        this.sort = data.sort;
        this.actionDate = data.actionDate;
        this.sessionId = data.sessionId;
        this.destinationOrgId = data.destinationOrgId;
        this.destinationOrgDomain = data.destinationOrgDomain;
        this.destinationOrgName = data.destinationOrgName;
        this.destinationPrjId = data.destinationPrjId;
        this.destinationPrjName = data.destinationPrjName;
        this.orgActionId = data.orgActionId;
        this.orgActionDomain = data.orgActionDomain;
        this.orgActionName = data.orgActionName;
        this.prjActionId = data.prjActionId;
        this.prjActionName = data.prjActionName;
        this.userActionId = data.userActionId;
        this.userActionEmail = data.userActionEmail;
        this.userActionName = data.userActionName;
        this.contentTypes = data.contentTypes;
        this.hitNumber = data.hitNumber;
        this.operationScreen = data.operationScreen;
        this.viewName = data.viewName;
    }
}
  
export default FilterByDrillDownDto;
  